'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _merge2 = require('lodash/merge');

var _merge3 = _interopRequireDefault(_merge2);

exports.default = configureStore;

var _redux = require('redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _capeFirebase = require('cape-firebase');

var _capeReduxReducer = require('cape-redux-reducer');

var _capeReduxReducer2 = _interopRequireDefault(_capeReduxReducer);

var _reduxWindowsize = require('redux-windowsize');

var _reduxHistorySync = require('redux-history-sync');

var _reduxDevtoolsExtension = require('redux-devtools-extension');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* global window */
// Configure and create Redux store.
// Function requires an initialState object.


function configureStore(initialState, firebase) {
  var calculatedState = {
    history: (0, _reduxHistorySync.getInitState)(window.location, window.document.title, window.history),
    session: {
      currentYear: new Date().getFullYear()
    }
  };
  var store = (0, _redux.createStore)(_capeReduxReducer2.default, (0, _merge3.default)(initialState, calculatedState), (0, _reduxDevtoolsExtension.composeWithDevTools)((0, _redux.applyMiddleware)((0, _reduxHistorySync.historyMiddleware)(window.history), // Build func to listen for firebase changes and dispatch to redux.
  (0, _capeFirebase.middleware)(firebase), _reduxThunk2.default)));
  (0, _reduxHistorySync.syncHistoryWithStore)(store, window);
  (0, _capeFirebase.reduxFirebase)(firebase, store);
  store.dispatch((0, _reduxWindowsize.createSizeAction)(window));
  store.dispatch((0, _reduxWindowsize.createRemAction)(window));
  (0, _reduxWindowsize.listenResize)(store, window);
  return store;
}

module.exports = exports['default'];